import React, { ReactNode } from 'react';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { Icons } from '../../../components/atoms/SVG';
import { StatusInfo, StatusInfoModifier } from './partials/StatusInfo';
import { Content } from './partials/Content';
import { Message } from './partials/Message';
import { StatusInfoIcon } from './partials/StatusInfoIcon';

type StatusInfoErrorWithRequestId = {
  requestId?: string;
  modifier?: StatusInfoModifier;
  message?: ReactNode;
  additionalContent?: ReactNode;
  role?: 'status' | 'alert';
  dataFormStatus?: 'fail';
};

export function StatusInfoErrorWithRequestId({
  message,
  modifier,
  requestId,
  role = 'status',
  dataFormStatus,
  additionalContent,
}: StatusInfoErrorWithRequestId) {
  const { t } = useSonTranslation('ErrorInfo');

  return (
    <StatusInfo modifier={modifier} role={role} dataFormStatus={dataFormStatus}>
      <Content>
        <StatusInfoIcon icon={Icons.FEEDBACK_ERROR} />
        <Message>{message || t('serverError.text')}</Message>
      </Content>
      {requestId && (
        <p className="status-info__content">
          <dfn className="status-info__definition">{t('serverError.logfileEntry')}: </dfn>
          <span className="status-info__text">{requestId}</span>
        </p>
      )}
      {additionalContent}
    </StatusInfo>
  );
}
